import React, { useEffect, useRef } from "react";

/** Fondo del interior: negro obsidiana con aurora de seda carmesí, malla en
 *  perspectiva, brasas y un foco que sigue al cursor. Silencioso pero vivo. */

const GLINTS = Array.from({ length: 11 }, (_, i) => ({
  id: `glint-${i}`,
  left: `${5 + i * 9}%`,
  top: `${10 + ((i * 31) % 74)}%`,
  delay: `${i * 1.9}s`,
  dur: `${13 + (i % 5) * 4}s`,
  size: i % 3 === 0 ? 3 : 2,
}));

export const NoirBg = () => {
  const spotRef = useRef(null);

  useEffect(() => {
    const el = spotRef.current;
    if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let frame = 0;
    const onMove = (e) => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        el.style.setProperty("--mx", `${e.clientX}px`);
        el.style.setProperty("--my", `${e.clientY}px`);
        frame = 0;
      });
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onMove);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <>
      <div className="noir-aurora" aria-hidden="true">
        <i /><i /><i />
      </div>
      <div className="noir-grid" aria-hidden="true" />
      <div className="noir-veil" aria-hidden="true" />
      <div className="noir-spot" ref={spotRef} aria-hidden="true" />
      <div className="noir-glints" aria-hidden="true">
        {GLINTS.map((g) => (
          <span key={g.id} style={{
            left: g.left, top: g.top, width: g.size, height: g.size,
            animationDelay: g.delay, animationDuration: g.dur,
          }} />
        ))}
      </div>
    </>
  );
};

export default NoirBg;
